window.addEventListener('load', function() {

	var cssDataLive = document.getElementById('Datalive');
	if (cssDataLive) {
		if (cssDataLive.parentNode) {
			cssDataLive.parentNode.removeChild(cssDataLive);
		}
	}

	/**
	 * Setup do token de validação no cabeçalho
	 */
	$.ajaxSetup({
		headers: {
			'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		}
	});

	var mobileScreen = 576;

	if (screen.width <= mobileScreen) {
		$('#clients-home').addClass('default-section centered-content section');
	}

	$('#slick-brands').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 5000,
		pauseOnHover: false,
		arrows: false,
		dots: false,
		infinite: true,
		//variableWidth: true,
		autoplaySpeed: 5000,
        //speed: 2000,
		//cssEase:'linear',
		responsive: [
			{
			  breakpoint: 600,
			  settings: {
				slidesToShow: 3,
				slidesToScroll: 1
			  }
			}
		  ]
	});

 	$('.mask-solid').click(function() {
		$(body).removeClass('active-popup');
	});

	$('.btn-close-popup').click(function() {
		$(body).removeClass('active-popup');
	});

	var btnSend = document.getElementById('send-contact-btn');
	

	btnSend.addEventListener('click', function() {
		
		// VAI ENVIAR O EMAIL 
		var nome     = document.getElementById('name');
		var email    = document.getElementById('email');
		var company  = document.getElementById('company');
		var phone    = document.getElementById('phone');
		var office   = document.getElementById('office'); 
		var checkbox = document.getElementById('check');

		
		if ( nome.value == "" || email.value == "" || phone.value == "" || company.value == "" || office.value == "" || !checkbox.checked)
		{
			

			Swal.fire({
				heightAuto: false,
				icon: 'error',
				title: "Ops",
				text: "Algum campo ficou em branco?"
			});
			
		}	else
		{
			var id = 'form-contact';
		
		 if(APP.validaForm($("#form-contact"))){
				$("#send-contact-btn").text("Enviando");
				var dados = $("#form-contact").serialize();

				Swal.fire({
					heightAuto: true,
					icon: "success",
					title: "Obrigado!",
					text: "Recebemos o seu contato"
				});

				jQuery.ajax({
					type: "POST",
					url: base_url+"/send-contato",
					data: dados,
					success: function(msg) {
						if (msg.type == "success"){
							document.getElementById(id).reset();
							
							$("#send-contact-btn").attr("disabled", false);
							$(".send-contact-btn").attr("disabled", false);

							// url = 'http://www-maiomarketing-com-br.rds.land/contato';
							// window.open(url, "_blank");
							
						} else if(msg.type == "error"){
							$("#send-contact-btn").attr("disabled", false);
							$(".send-contact-btn").attr("disabled", false);

							Swal.fire({
								heightAuto: false,
								icon: 'error',
								title: "Ops, ocorreu um erro",
								text: "Por favor,tente novamente",
							});
						}
						
						$("#send-contact-btn").attr("disabled", false);
						$(".send-contact-btn").attr("disabled", false);
					},
					error: function(err) {
						console.log(err);

						$("#send-contact-btn").attr("disabled", false);
						$(".send-contact-btn").attr("disabled", false);
						
						Swal.fire({
							heightAuto: false,
							icon: 'error',
							title: "Ops, ocorreu um erro",
							text: "Por favor,tente novamente",
						});
					},	
					complete: function(){
						console.log("complete");
						$("#send-contact-btn").attr("disabled", false);
						$(".send-contact-btn").attr("disabled", false);
					},
				});
				
			}else{
				/*
				$("#send-contact-btn").attr("disabled", false);
				$(".send-contact-btn").attr("disabled", false);
				Swal.fire({
					heightAuto: false,
					icon: 'error',
					title: "Algum campo ficou em branco",
					text: "Por favor preencha e tente novamente",
				});
				*/
				
			}
		}

		
	}); 
});

window.addEventListener('load', function() {

	var cssDataLive = document.getElementById('Datalive');
	if (cssDataLive) {
		if (cssDataLive.parentNode) {
			cssDataLive.parentNode.removeChild(cssDataLive);
		}
	}

	/**
	 * Setup do token de validação no cabeçalho
	 */
	$.ajaxSetup({
		headers: {
			'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		}
	});

	var mobileScreen = 576;

	if (screen.width <= mobileScreen) {
		$('#clients-home').addClass('default-section centered-content section');
	}

	$('#slick-brands').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 5000,
		pauseOnHover: false,
		arrows: false,
		dots: false,
		infinite: true,
		//variableWidth: true,
		//autoplaySpeed: 0,
        //speed: 2000,
		//cssEase:'linear',
		responsive: [
			{
			  breakpoint: 600,
			  settings: {
				slidesToShow: 3,
				slidesToScroll: 1
			  }
			}
		  ]
	});

 	$('.mask-solid').click(function() {
		$(body).removeClass('active-popup');
	});

	$('.btn-close-popup').click(function() {
		$(body).removeClass('active-popup');
	});

	var btnSend = document.getElementById('send-job-btn');

	btnSend.addEventListener('click', function() {
		
		if (!$('#check').is(':checked')) {
			Swal.fire({
				heightAuto: false,
				icon: 'error',
				title: "Campo em branco",
				text: "Favor autorizar o tratamento dos dados para prosseguir",
			});
		} else {
			$("#send-job-btn").attr("disabled", true);

			var id = 'form-job';
		
			if(APP.validaForm($("#form-job"))){
				$("#send-job-btn").text("Enviando");
				var dados = $("#form-job").serialize();

				jQuery.ajax({
					type: "POST",
					url: base_url+"/send-job",
					data: dados,
					success: function(msg) {
						if (msg.type == "success"){
							document.getElementById(id).reset();
							
							$("#send-job-btn").attr("disabled", false);

							Swal.fire({
								heightAuto: false,
								icon: 'success',
								title: "Enviado com sucesso!",
								text: "",
							});
							
						} else if(msg.type == "error"){
							$("#send-job-btn").attr("disabled", false);

							Swal.fire({
								heightAuto: false,
								icon: 'error',
								title: "Ops, ocorreu um erro",
								text: "Por favor,tente novamente",
							});
						}
						
						$("#send-job-btn").attr("disabled", false);
					},
					error: function(err) {
						console.log(err);

						$("#send-job-btn").attr("disabled", false);
						
						Swal.fire({
							heightAuto: false,
							icon: 'error',
							title: "Ops, ocorreu um erro",
							text: "Por favor,tente novamente",
						});
					},	
					complete: function(){
						console.log("complete");
						$("#send-job-btn").attr("disabled", false);
					},
				});
				
			}else{
				$("#send-job-btn").attr("disabled", false);
				Swal.fire({
					heightAuto: false,
					icon: 'error',
					title: "Algum campo ficou em branco",
					text: "Por favor preencha e tente novamente",
				});
			}
		}
	}); 
});

/**
 * Objeto público com  métodos usados ao longo do app
 */

var speedometer = false;
var biAlready = false;
var miAlready = false;
var percentAlready2 = false;
var lastScrollTopH = 0;
var lastScrollTopA = 0;
var currentElemActive = 0;

var APP = {
	init: function () {
		console.log("JS init");
		var _this = this;
        _this.binds();
        _this.initSliders();
	},

	binds: function(){
		$("#hamburguer-btn, #hamburguer-btn-mobile").on("click", function(e){
			$("html, body").toggleClass("menu-mobile-active");

			if ($("html, body").hasClass("menu-mobile-active")) {
				$("#wrapper-menu-mobile").css("display", "block");
			} else {
				setTimeout(function() {
					$("#wrapper-menu-mobile").css("display", "none");
				}, 200);
			}
		});

		$(".btn-go-to-top").on("click", function(){
			$("html, body").animate({
				scrollTop: $($("header.header")).offset().top
			}, 700);
		});

		$(".scroll-to-target").on("click", function(){
			var target = $(this).data("target");

			$("html, body").animate({
				scrollTop: $($("#"+target)).offset().top
			}, 600);
		});
		
		$(".scroll-section").on("click", function(){
			fullpage_api.moveSectionDown();
		});

		$(".go-to-slide").on("click", function(){
			var carousel = $(this).data("carousel");
			var target = $(this).data("target");

			$(carousel).slick('slickGoTo', target);

			if ($(window).innerWidth() > 991) {
				if ($('#metodologias-carousel')) {
					$("html, body").animate({
						scrollTop: $($(".slide-section-" + target)).offset().top
					}, 0);
				}
			}
		});

		$(".toggle-modal").on("click", function(){
			var modal = $(this).data("modal");
			var video = $(this).data("video");

			APP.toggleModal(modal, video);
		});
		
		$(".btn-toggle-mobile").on("click", function(){
			APP.openMobileMenu();
		});

		$('#metodologias-carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide){
			event.preventDefault();
			var navigation = $(this).data("navigation");

			$('#'+navigation+' button').removeClass("active");
			$('#'+navigation+' button[data-target="'+ nextSlide +'"]').addClass("active");
		});

		$(".contact-form").submit(function(event) {
			event.preventDefault();
			var form = $(this).data("form");
			APP.enviarContato(form);
		});

		$(document).ready(function() {
			if ($('#fullpage').length) {
				$('#fullpage').fullpage({
					scrollBar: true,
					scrollOverflow: false,
					autoScrolling: true,
					scrollHorizontally: false,
					bigSectionsDestination: 'top',
					fixedElements: 'header, footer',
				});
			}
		});

		$(window).on("scroll", function(){
			APP.hideUpBtn();
			APP.watchAnimations();
			APP.watchSlidesCustomer();
			APP.watchHeader();
			APP.watchFocusElements();
		});
		
		$(document).ready(function() {
			APP.hideUpBtn();
			APP.watchAnimations();
			APP.watchSlidesCustomer();
		});
	},

	initSliders: function () {
		if ($("#metodologias-carousel")) {
			$('#metodologias-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				fade: true,
				dots: false,
				// appendDots: "$('#metodologias-nav')"
			});
		}

		if ($("#testmonials-carousel")) {
			$('#testmonials-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				fade: true,
				dots: false,
				infinite: false,
				// appendArrows: '.carousel-arrows',
				prevArrow: $('.carousel-arrows .slick-prev'),
				nextArrow: $('.carousel-arrows .slick-next')
			});
		}
	},

	hideUpBtn: function () {
    if ($(".btn-go-to-top")) {
      var doc = document.documentElement;
      var screenTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

      if (screenTop >= 400) {
        $(".btn-go-to-top").addClass("btn-show");
      } else {
        $(".btn-go-to-top").removeClass("btn-show");
      }
    }
	},

	playPauseVideo: function(video) {
		var mediaVideo = $("#"+video).get(0);

		if (mediaVideo.paused) {
			console.log("PLAY!!!");
			mediaVideo.play();
		} else {
			console.log("PAUSE!!!");
			mediaVideo.pause();
		}
	},

	toggleModal: function(modal, video) {
		var mediaVideo = $("#"+video).get(0);

		if ($("html, body").hasClass("modal-active")) {
			$("html, body").removeClass("modal-active");
			$("#"+modal).removeClass("modal-active");

			if (mediaVideo) {
				mediaVideo.pause();
			}
		} else {
			$("html, body").addClass("modal-active");
			$("#"+modal).addClass("modal-active");

			if (mediaVideo) {
				mediaVideo.play();
			}
		}
	},

	closeModal: function(modal) {
		$("html, body").removeClass("modal-active");
		$("#"+modal).removeClass("modal-active");
	},
    
	openMobileMenu: function(){
		if(!$('body').hasClass('sub-menu-aberto-body')){
			$('body, html').toggleClass('menu-mobile-open');

			if( $('body, html').hasClass('menu-mobile-open') ){
				$('.btn-toggle-mobile').addClass('menu-collapsed');
				$("#hamburger-btn, #hamburger-btn-fixed").removeClass("to-arrow");
				$("#hamburger-btn, #hamburger-btn-fixed").addClass("from-arrow");
				$('html').css('overflow-y', 'hidden');

				$.fn.fullpage.setAllowScrolling(false);
			} else {
				$('.btn-toggle-mobile').removeClass('menu-collapsed');
				$("#hamburger-btn, #hamburger-btn-fixed").addClass("to-arrow");
				$("#hamburger-btn, #hamburger-btn-fixed").removeClass("from-arrow");
				$('html').css('overflow-y', 'inherit');

				$.fn.fullpage.setAllowScrolling(true);
			}
		}
	},

	watchHeader: function() {
		var st = window.pageYOffset || document.documentElement.scrollTop;

		// SE SCROLLANDO PARA CIMA
		if (st < lastScrollTopH){
			if ($(window).scrollTop() > ($(window).height() / 1.5)) {
				// SE SCROLLANDO PARA CIMA & NÃO NA PRIMEIRA SEÇÃO
				$("#header-fixed").addClass("header-visible");
			} else {
				// SE SCROLLANDO PARA CIMA NA PRIMEIRA SEÇÃO
				$("#header-fixed").removeClass("header-visible");
			}
		} else {
		// SE SCROLLANDO PARA BAIXO
			if ($(window).scrollTop() > ($(window).height() / 1.5)) {
				// SE SCROLLANDO PARA BAIXO & NÃO NA PRIMEIRA SEÇÃO
				$("#header-fixed").removeClass("header-visible");
			}
		}

		lastScrollTopH = st <= 0 ? 0 : st;
	},

	watchSlidesCustomer: function() {
		if ($("#metodologias").length) {
			$(".slide-section").each(function(i) {
				if (APP.isOnScreen($(".slide-section-"+i))) {
					$("#metodologias-carousel").slick('slickGoTo', i);
				}
			});
		}
	},

	watchAnimations: function() {
		if (APP.isOnScreen($("#animated-charts"), "center")) {
			$("#animated-charts").addClass("animate");
			
			if (!$("#animated-charts").hasClass("count-increased")) {
				$("#animated-charts").addClass("count-increased");

				$(".increase-percent").each(function(i) {
					APP.increaseCount($(this)[0].id, 0, $(this).data("value"));
				});
			}
		} else {
			$("#animated-charts").removeClass("animate");
			
			if ($("#animated-charts").hasClass("count-increased")) {
				$("#animated-charts").removeClass("count-increased");

				$(".increase-percent").each(function(i) {
					APP.decreaseCount($(this)[0].id, 0, $(this).data("value"));
				});
			}
		}
	},

	increaseCount: function(id, count, value) {
		var timeout = (1 / value) * 1000;

		$("#"+id).text(count);

		if (count < value) {
			setTimeout(() => {
				APP.increaseCount(id, count + 1, value);
			}, timeout);
		}
	},

	decreaseCount: function(id, count, value) {
		var timeout = (1 / value) * 1000;

		$("#"+id).text(count);

		if (count > value) {
			setTimeout(() => {
				APP.increaseCount(id, count - 1, value);
			}, timeout);
		}
	},

	watchFocusElements: function() {
		var arr = ["0", "1", "2", "3", "4"];

		arr.map((item) => {
			if (APP.isOnScreen($(".content-focus-" + item), "top")) {
				var filteredArr = arr.filter(function (val) { return parseInt(item) != parseInt(val) });
				var items = $(".content-focus-" + item).data("items");

				$(filteredArr).map((_index, value) => {
					$("#chart-" + value).removeClass("active");
					
					var respecItems = $(".content-focus-" + value).data("items");
					$(respecItems).map((_index, value) => {
						$("#how-we-help-" + value).removeClass("active");
					});
				});
				
				if (!$("#chart-" + item).hasClass("active")) {
					$("#chart-" + item).addClass("active");
				}

				$(items).map((_indexb, valueb) => {
					if (!$("#how-we-help-" + valueb).hasClass("active")) {
						$("#how-we-help-" + valueb).addClass("active");
					}
				});
			}
		});
	},

	isOnScreen: function(element, anchor) {
		if (element.offset()) {
			var elemPos = element.offset().top;
			var elemHeight = element[0].offsetHeight;

			var elemTop = (elemPos + elemHeight) - $(window).scrollTop() - 100;

			if (anchor === "top") {
				var elemTop = elemPos - $(window).scrollTop() + 400;
			} else if (anchor === "bottom") {
				var elemTop = elemPos - $(window).scrollTop();
			}

			var screenHeight = $(window).height();
			var isOnTop = (elemTop > screenHeight) ? false : true;

			if (isOnTop) {
				var isOnTop = ((elemPos + elemHeight) > $(window).scrollTop());
			}

			return isOnTop;
		}
	},

	validaCampoEmail: function(element) {
		var value = element.value;
		var regex = /^[A-Za-z0-9_\-\.]+@[A-Za-z0-9_\-\.]{2,}\.[A-Za-z0-9]{2,}(\.[A-Za-z0-9])?/;

		if (regex.test(value)) {
				$(element).removeClass('error');
				return;
		} else {
			$(element).addClass('error');
			
			Swal.fire({
				heightAuto: false,
				icon: 'error',
				title: "E-mail informado inválido!",
				text: "Ex: exemplo@exemplo.com",
			});
		}
	},

	validaForm: function(form){
		var _this = this;

		var required = form.find('.required');
		var select = form.find('select.required');
		var requiredSelect = form.find('select.required');
		var aceite = form.find('.aceite');
		var requiredAceite = form.find('.aceite .required:checked');
		var req = 0;
		var reqSel = 0;
		var reqAc = 0;
		var classe;

		for(i=0;i<required.length;i++){
			if($(required[i]).val() == "" && $(required[i]).prop('disabled') != true){
				classe = $(required[i]).attr('class');
				
				if(classe.search("required") != -1){	
					$(required[i]).addClass('error');
				}
				req = 1;
			}else{
				classe = $(required[i]).attr('class');
				
				if(classe.search("error") != -1){
					$(required[i]).removeClass('error');
				}
			}
		}

		if(select.length > 0){
			for(i=0;i<requiredSelect.length;i++){
				if($(requiredSelect[i]).find(":selected").text() == "Selecione"){
					classe = $(requiredSelect[i]).attr('class');
					
					if(classe.search("required") != -1){	
						$(requiredSelect[i]).addClass('error');
					}
					reqSel = 1;
				}else{
					classe = $(requiredSelect[i]).attr('class');
					
					if(classe.search("error") != -1){
						$(requiredSelect[i]).removeClass('error');
					}
				}
			}
		}

		if(aceite.length > 0){
			_this.projetoAceite.removeClass('error');
			if(requiredAceite.length == 0){
				_this.projetoAceite.addClass('error');
				reqAc = 1;
			}else{
				_this.projetoAceite.removeClass('error');
			}
		}
		
		if(req == 1 || reqSel == 1 || reqAc == 1){
			return false;
		}else if(req == 0 && reqSel == 0 && reqAc == 0){
			return true;
		}
	},
};

//expondo projeto padrao
window.addEventListener('load', function() {
	APP.init();
});

/**
 * Páginas
 */
//require('./uteis');